import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions, selectors} from '../Redux/index';
import {i18n, formatTableDataForExport, formatDate} from '../Utility/Format';

import ForwardTable from '../Components/Tables/ForwardTable';
import LastUpdateMessage from '../Components/Widgets/LastUpdateMessage';
import TableExport from '../Components/Widgets/TableExport';
import {ValueDateCalendarToggle} from './Application/ValueDateCalendar';
import StageActions from '../Components/Widgets/StageActions';


/**
 * The Forward view container. One of the top-level views of the application.
 */
class Forward extends React.Component {

    componentDidMount() {
        this.props.getForwardData();
    }

    onDownload(type) {
        return () => this.props.downloadFile(type, formatTableDataForExport({
            key: "forward",
            title: "Forward",
            data: this.props.table,
            lang: this.props.locale
        }));
    };

    render() {
        const onClick = {
            pdf: this.onDownload('pdf'),
            xlsx: this.onDownload('xlsx'),
            csv: this.onDownload('csv')
        };

        const {table, locale} = this.props;
        const isEmpty = !table.data || table.data.length === 0;
        //console.log("Forward.js - ",locale);
       
        return (
            <div className="forward">

                {
                    isEmpty ? <center>{i18n(table.data ? 'dbm.table.emptyData' : 'dbm.table.loadingData')}</center> : (
                        <div>
                            {
                                table.data.map((table) => {
                                    const formattedTenors = table.tenors.map(tenor => ({
                                        ...tenor,
                                        valueDate: formatDate(tenor.valueDate, locale)
                                    }));
                                    return (
                                        <ForwardTable
                                            key={table.ccyPair}
                                            rows={formattedTenors}
                                            currencyPair={table.ccyPair}
                                            locale={locale}
                                        />
                                    )
                                })
                            }

                            <LastUpdateMessage date={table.lastUpdate}/>
                        </div>
                    )
                }

                <StageActions
                    left={
                        <TableExport
                            label={i18n('dbm.stage.nav.forward')}
                            onClickPDF={onClick.pdf}
                            onClickCSV={onClick.csv}
                            onClickXLSX={onClick.xlsx}
                            aria-label={i18n('dbm.stage.nav.forward')}
                        />
                    }
                    right={
                        <ValueDateCalendarToggle onTogglePanel={this.props.onValuedateClick} />
                    }
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        downloadFile: (type, data) => {
            dispatch(actions.Data.Download.requestDownloadFile({type: type, data: {body: JSON.stringify(data)}}))
        },
        getForwardData: () => {
            dispatch(actions.Data.Reload.sagaReloadData());
        },
        onCloseOptionsPanel: () => {
            dispatch(actions.UI.OptionsMenu.toggleOptionsForm());
            dispatch(actions.UI.OptionsMenu.toggleOptionsMenu());
        },
        onValuedateClick: () => {
            dispatch(actions.UI.OptionsMenu.toggleValueDateCalendar());
            dispatch(actions.UI.OptionsMenu.toggleOptionsMenu());
        }
    }
};

const mapStateToProps = (state) => {
    return {
        table: selectors.Data.Forward.getData(state),
        isValueDateVisible: selectors.UI.OptionsMenu.isValueDateVisible(state),
        locale: selectors.UI.Locale.getLocale(state),
        currencies: selectors.Data.Currency.getCurrencies(state)
    };
};

Forward.propTypes = {

    /**
     * the forward data
     */
    table: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                ccyPair: PropTypes.string.isRequired,
                tenors: PropTypes.array.isRequired
            })
        ),
        lastUpdate: PropTypes.string
    })

};

export default connect(mapStateToProps, mapDispatchToProps)(Forward);